import { useTranslation } from "@msuite/ui/localization";
import { IconTag, Tag } from "@msuite/ui/tag";
import type { Color } from "@msuite/utils/colors";
import type { SettlementRecordState } from "@msuite/utils/partnerships";

/** Props Interface */
interface SettlementStateTagProps {
	state: SettlementRecordState;
	/** `plain` drops the chip's frame, for a list whose rows already carry their own. */
	variant?: "default" | "plain";
}

/** The colour each state of a settlement record is drawn in, approval aside. */
const STATE_COLORS: Record<Exclude<SettlementRecordState, "approved">, Color> = {
	open: "amber",
	submitted: "sky",
	reviewed: "accent",
};

/**
 * Where a settlement record stands, named the same way on both sides of the partnership. An
 * approved record carries the badge the approve button carries, so the partner reads the host's
 * answer in the shape the host gave it.
 */
export function SettlementStateTag({ state, variant = "default" }: SettlementStateTagProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	if (state === "approved") {
		return (
			<IconTag
				iconName="BadgeCheck"
				color="emerald"
				variant={variant}
			>
				{t("partners.booking_state.approved")}
			</IconTag>
		);
	}
	return (
		<Tag
			variant={variant}
			color={STATE_COLORS[state]}
		>
			{t(`partners.booking_state.${state}`)}
		</Tag>
	);
}
